import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=c3f808da&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=ts"
export * from "./Activities.vue?vue&type=script&lang=ts"
import style0 from "./Activities.vue?vue&type=style&index=0&id=c3f808da&prod&lang=scss&scoped=true"
import style1 from "./Activities.vue?vue&type=style&index=1&id=c3f808da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f808da",
  null
  
)

export default component.exports